import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/megaPack';
import { pricing } from '../data/pricing';
export function Bonuses() {
  return <section className="bg-cream-50 py-10 sm:py-20" aria-labelledby="bonos" data-id="element-18" data-mp="av352qvvf103">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-19" data-mp="asz34ehj8c2g">
        <SectionHeading eyebrow="Incluidos gratis" title="5 bonos estratégicos" subtitle="Sin costo extra — incluidos en la oferta." data-id="element-20" data-mp="ft4o5btar0bk" />

        <ul className="mt-6 divide-y divide-gold-500/25 overflow-hidden rounded-2xl border border-gold-500/35 bg-gold-50 sm:mt-10" data-id="element-21" data-mp="5vqmwjfy2i3u">
          {bonuses.map(bonus => <li key={bonus.code} className="flex items-start gap-3 px-4 py-3.5 transition-colors duration-150 ease-out hover:bg-gold-200/40 sm:gap-4 sm:px-6 sm:py-5" data-id="element-22" data-mp="3o3porp60vcr4">
              <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gold-500 font-display text-[0.7rem] font-900 text-teal-900 sm:h-9 sm:w-9 sm:text-xs" data-id="element-23" data-mp="1m8fb98f3rvpf">
                {bonus.code}
              </span>
              <div className="min-w-0 flex-1" data-id="element-24" data-mp="3dg4xot4brwim">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1" data-id="element-25" data-mp="3dd8zr4sh97u6">
                  <h3 className="font-display text-sm font-800 uppercase leading-snug text-teal-900 sm:text-base" data-id="element-26" data-mp="3r68h7cbtlc4d">
                    {bonus.title}
                  </h3>
                  <span className="text-[0.75rem] text-clay line-through sm:text-sm" data-id="element-27" data-mp="2zesm0tw76h2j">
                    {pricing.bonusesValue}
                  </span>
                  <span className="rounded-full bg-teal-800 px-2 py-0.5 font-display text-[0.6rem] font-800 uppercase tracking-[0.12em] text-cream-50 sm:text-[0.65rem]" data-id="element-28" data-mp="2uiu1xihwjl7x">
                    Hoy gratis
                  </span>
                </div>
                <p className="mt-1 text-[0.8rem] leading-relaxed text-ink/70 sm:text-sm" data-id="element-29" data-mp="np004uox2gap">
                  {bonus.description}
                </p>
              </div>
            </li>)}
        </ul>

      </div>
    </section>;
}